import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import * as React from 'react';
export var Context = /*#__PURE__*/React.createContext({});
export default function MotionProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: props
  }, children);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-motion/es/context.js
// module id = 606
// module chunks = 0